// src/app/views/home/Home.tsx

'use client';

import React, { useState, useCallback, useEffect, useRef } from 'react';
import styles from './Home.module.scss';
import TypingEffect from '@/utils/typing-effect';
import useMixpanelTracking from '@/hooks/useMixpanelTracking';
import TerminalHeader from '@/views/terminal-header/TerminalHeader';

interface Prompt {
  title: string;
  description: string;
  button?: React.ReactNode;
}

const prompts: Prompt[] = [
  {
    title: `Why ChadAI?`,
    description: `> Being a Chad is a full-time job. We full-port based on what anons drop in the group chat or Elon’s next tweet, but even then, staying on top of messages and socials is impossible for any one Chad. What if we could tap into a collective Degenerative AI superintelligence?

> ChadAI is a community-led effort to empower Chads with degenerate tendencies to buy and sell animal pictures and funny money coins. At a time when the tech overlords are hurtling humanity towards the existential threat of extinction as a casualty of the AI arms race, we need a decentralized way to put power back into the hands of the people more than ever.`,
  },
  {
    title: `What is ChadAI?`,
    description: `> Led by Chad Altmeme, ChadAI has pioneered the ChadGPT Degenerative AI model behind crypto’s most degen AI assistant, Chad Bot. Running on the latest WGMIDIA Muscle Memory A69 Quantum Processing Unit (QPU), the Chad Language Model (CLM) is trained on an unprecedented 420 trillion parameters from social sentiment and real-time omni-chain market data to help Chads ape with unprecedented conviction.`,
  },
  {
    title: `Who is Chad Altmeme?`,
    description: `> As his name describes, Chad Altmeme loves altcoins and memes, but more importantly, he loves his planet and all the earthlings that inhabit it. Chad is growing increasingly concerned about the centralized control of AI and the existential risks associated with corporations jostling to own humanity’s collective intelligence. Chad is a former biochemical engineer who worked for a pharma lab engineering the world’s highest grade therapeutic Ketamine. His life and mission drastically changed after a brain implant mishap. Learn more about his story by clicking below`,
    button: (
      <a
        href='https://twitter.com/ChadAIdotorg/status/1795251516720529635'
        className={styles['home__button']}
        target='_blank'
        rel='noopener noreferrer'
      >
        {`Book of Chad`} <img src={'/Vector_black.svg'} alt='Vector arrow' />
      </a>
    ),
  },
  {
    title: `What is Chad Bot?`,
    description: `> Crypto’s Most Degen AI Assistant
Starting with a Telegram mini-app and browser extension, Chad Bot is always by your side across your entire trading experience.
    
Chad Bot speaks fluent CT and taps into the Chad Language Model to surface real-time alpha and market intelligence straight from the chainverse.
    
Just say ‘Hey Chad’ to unlock:
  • AI-powered token analysis
  • Real-time social sentiment
  • Chat groups summaries
  • Cross-chain trading

No dashboards. No brain chip required. Just pure degenerative intelligence in your pocket.`,
  },
];

const Home: React.FC = () => {
  const [selectedPrompt, setSelectedPrompt] = useState<Prompt | null>(null);
  const { track } = useMixpanelTracking();
  const descriptionRef = useRef<HTMLDivElement>(null);

  const handlePromptClick = useCallback(
    (prompt: Prompt) => {
      if (selectedPrompt?.title === prompt.title) return;
      setSelectedPrompt(prompt);
      void track('FAQ Item Clicked', { prompt: prompt.title });
    },
    [selectedPrompt, track],
  );

  useEffect(() => {
    if (descriptionRef.current) {
      const scrollToBottom = () => {
        descriptionRef.current!.scrollTop =
          descriptionRef.current!.scrollHeight;
      };

      // Set up a MutationObserver to watch for changes in the description div
      const observer = new MutationObserver(scrollToBottom);
      observer.observe(descriptionRef.current, {
        childList: true,
        subtree: true,
      });

      // Clean up the observer when the component unmounts
      return () => observer.disconnect();
    }
  }, [selectedPrompt]);

  return (
    <div className={styles.home}>
      <TerminalHeader />
      <div className={styles['home__content']}>
        {selectedPrompt ? (
          <>
            <div className={styles['home__prompt-title']}>
              {`> ${selectedPrompt.title}`}
            </div>
            <div
              ref={descriptionRef}
              className={styles['home__prompt-description']}
            >
              <TypingEffect
                text={selectedPrompt.description}
                className={styles['home__button-wrapper']}
              >
                {selectedPrompt.button && (
                  <div className={styles['home__button-container']}>
                    {selectedPrompt.button}
                  </div>
                )}
              </TypingEffect>
            </div>
          </>
        ) : (
          <div className={styles['home__placeholder']}>
            {`> Select a prompt to see more information.`}
          </div>
        )}
      </div>
      <div className={styles['home__prompts']}>
        {prompts.map((prompt, index) => (
          <div
            key={index}
            className={`${styles['home__prompt-button']} ${
              selectedPrompt?.title === prompt.title
                ? styles['home__prompt-button--disabled']
                : ''
            }`}
            onPointerDown={() => handlePromptClick(prompt)}
          >
            {prompt.title} <img src={'/Vector.svg'} alt='Vector arrow' />
          </div>
        ))}
      </div>
    </div>
  );
};

export default Home;
